import TierDeviationSelector from './TierDeviationSelector';
export default TierDeviationSelector;
